const {required} = require("@common/react/cs-form/validators/required");

exports.scatterPlotFormConfig = {
    fields: {
        title: {
            transforms: ["trim"],
            validators: [required],
            debounce: true,
        },
    },
};
